import { Dialog } from '@progress/kendo-react-dialogs';
import { RadioButton } from '@progress/kendo-react-inputs';
import React, { useState } from 'react';
import cancellationReasons from './Reasons.json';

function CancelSubscriptionDialog({ endDate, onConfirm, onClose }) {

    const [showConfirmation, setShowConfirmation] = useState(false);

    return (
        <Dialog
            title="Cancel subscription"
            onClose={onClose}
            width="50%">
            {
                showConfirmation ? 
                <CancellationConfirmationForm
                    endDate={endDate}
                    onConfirm={onConfirm}
                    onUndo={onClose} /> :
                <CancellationReasonForm
                    onSubmit={() => setShowConfirmation(true)} />
            }
        </Dialog>
    )
}

export function CancellationReasonForm({ onSubmit }) {

    const [selectedReasonIndex, setSelectedReasonIndex] = useState(0);
    const [description, setDescription] = useState("");

    function handleSubmit() {
        onSubmit();
    }

    return (
        <div>
            <div className='font-size-1 my-4'>We appreciate you giving us a chance, and we'd love to learn more about how we could have made your experience better.</div>
            <div required className='font-size-3 mb-1'>Why do you want to cancel?</div>
            {
                cancellationReasons.map((reason, index) => (
                    <div key={index} className="lh-25">
                        <RadioButton
                            checked={selectedReasonIndex === index}
                            onChange={() => setSelectedReasonIndex(index)}
                            label={reason.optionText}
                            className="me-1" />
                    </div>
                ))
            }
            <div className='mt-4 font-size-2'>
                <label required for="textarea">
                    {
                        cancellationReasons[selectedReasonIndex].inputLabel
                    }
                </label>
                <span className='float-right op-35'>min 13 characters</span>
                <textarea placeholder='Briefly describe the reason' onChange={(e) => setDescription(e.target.value)} className='form-control mt-2' id="textarea"></textarea>
            </div>
            <div className='d-flex justify-content-end py-3 px-2'>
                <button onClick={handleSubmit} disabled={description.length < 13} className='btn btn-primary w-100 mt-2'>
                    Submit cancellation request
                </button>
            </div>
        </div>
    )
}

export function CancellationConfirmationForm({ endDate, onConfirm, onUndo }) {
    return (
        <div>
            <p>
                We are sorry to see you go!
            </p>
            <p>
                Your subscription plan is paid till <b>{ endDate }</b>. After that, we will downgrade you to the Free plan.
            </p>
            <p>
                If you would like to proceed with the cancellation, please confirm below.
            </p>
            <div className='w-100 d-flex justify-content-end py-3 px-2'>
                <button onClick={onConfirm} className='btn text-danger btn-link'>
                    Cancel Subscription
                </button>
                &nbsp;
                <button onClick={onUndo} className='btn btn-primary'>
                    Undo
                </button>
            </div>
        </div>
    )
}

export default CancelSubscriptionDialog;